import { useTranslation } from 'react-i18next';
import { useTheme } from './ThemeProvider';

/**
 * Sidebar theme switch — mirrors Ghost Screen Dashboard.dc.html:
 * label + track with accent knob that slides for dark/light.
 */
export function ThemeToggle() {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-pressed={isDark}
      aria-label={isDark ? t('theme.switchToLight') : t('theme.switchToDark')}
      className="flex w-full cursor-pointer items-center justify-between gap-2.5 rounded-[10px] border px-3 py-2.5 text-start font-sans text-[13px] font-semibold transition-[color,border-color] duration-150 hover:border-[var(--gs-accent)] hover:text-[var(--gs-ink)]"
      style={{
        background: 'var(--gs-panel2)',
        borderColor: 'var(--gs-line)',
        color: 'var(--gs-ink2)',
      }}
    >
      <span>{isDark ? t('theme.dark') : t('theme.light')}</span>
      <span
        className="relative block h-[18px] w-[34px] shrink-0 rounded-[9px]"
        style={{ background: 'var(--gs-line)' }}
        aria-hidden
      >
        <span
          className="absolute top-0.5 h-3.5 w-3.5 rounded-full transition-[inset-inline-start] duration-[160ms] ease-out"
          style={{
            insetInlineStart: isDark ? 18 : 2,
            background: 'var(--gs-accent)',
          }}
        />
      </span>
    </button>
  );
}
